import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const SearchingButton = styled.div`
  display: flex;
  height: 32px;
  min-width: 197px;
  align-items: center;
  padding: 6px 8px;
  grid-gap: 6px;
  color: ${colorTokens.primary.main};
  font-weight: 500;
  font-size: 14px;
  white-space: nowrap;
`;
